export default __webpack_public_path__ + "static/media/devices-1.af56bc61.jpg";